import { TabPanel, cssColorValue, Text } from '@spotify-internal/encore-web';
import {
  TWO_COLUMN_MAX_WIDTH,
  ONE_COLUMN_MAX_WIDTH,
  Grid,
} from '@spotify-internal/frodor-modules';
import React from 'react';
import styled from 'styled-components';
import { useReduxVideos } from './useReduxVideos';
import { VideoGroup } from './VideoGroup';
const GroupsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-block: 40px;
  padding-bottom: var(--encore-spacing-looser-5);
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-bottom: var(--encore-spacing-looser-4);
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-bottom: var(--encore-spacing-looser-3);
  }
  background-color: ${cssColorValue('backgroundBase')};
`;
export const CategoriesTabPanel = () => {
  const { videoCategories } = useReduxVideos();
  return (
    <>
      {videoCategories.allSlugs.map((slug: string) => {
        const id = videoCategories.slugToId[slug];
        const category = videoCategories.byId[id];
        return (
          <TabPanel key={`${category.name}-panel-keyboard`} value={category.id}>
            <Grid>
              <div
                style={{
                  gridColumn: '1 / -1',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Text variant="titleLarge" semanticColor="textBase">
                  {category.name}
                </Text>
                <Text variant="bodyMedium" semanticColor="textBase">
                  {category.body}
                </Text>
              </div>
            </Grid>
            <GroupsWrapper>
              {category.groups.map((groupId: string) => (
                <VideoGroup
                  key={groupId}
                  groupId={groupId}
                  showMoreButton={category.groups.length > 1}
                />
              ))}
            </GroupsWrapper>
          </TabPanel>
        );
      })}
    </>
  );
};
